var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 22.5H5V25.625H25V22.5Z",
    fill: "#FEC730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19.375H5V22.5H25V19.375Z",
    fill: "#E8A300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.25H5V19.375H25V16.25Z",
    fill: "#FEC730"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13.125H5V16.25H25V13.125Z",
    fill: "#E8A300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13.125H5L6.875 10H22.5L25 13.125Z",
    fill: "#FEC730"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 10H8.75L15 5.625L16.25 6.25L20.625 10Z",
    fill: "#E8A300"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.25H17.5C17.845 16.25 18.125 16.53 18.125 16.875V25.625H11.875V16.875C11.875 16.53 12.155 16.25 12.5 16.25Z",
    fill: "#D35230"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 16.25C25.5504 16.25 26.25 15.5504 26.25 14.6875C26.25 13.8246 25.5504 13.125 24.6875 13.125C23.8246 13.125 23.125 13.8246 23.125 14.6875C23.125 15.5504 23.8246 16.25 24.6875 16.25Z",
    fill: "url(#paint0_linear_1952_14)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 22.5C25.5504 22.5 26.25 21.8004 26.25 20.9375C26.25 20.0746 25.5504 19.375 24.6875 19.375C23.8246 19.375 23.125 20.0746 23.125 20.9375C23.125 21.8004 23.8246 22.5 24.6875 22.5Z",
    fill: "url(#paint1_linear_1952_14)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 25.625C25.5504 25.625 26.25 24.9254 26.25 24.0625C26.25 23.1996 25.5504 22.5 24.6875 22.5C23.8246 22.5 23.125 23.1996 23.125 24.0625C23.125 24.9254 23.8246 25.625 24.6875 25.625Z",
    fill: "url(#paint2_linear_1952_14)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 19.375C25.5504 19.375 26.25 18.6754 26.25 17.8125C26.25 16.9496 25.5504 16.25 24.6875 16.25C23.8246 16.25 23.125 16.9496 23.125 17.8125C23.125 18.6754 23.8246 19.375 24.6875 19.375Z",
    fill: "url(#paint3_linear_1952_14)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 16.25C6.17544 16.25 6.875 15.5504 6.875 14.6875C6.875 13.8246 6.17544 13.125 5.3125 13.125C4.44956 13.125 3.75 13.8246 3.75 14.6875C3.75 15.5504 4.44956 16.25 5.3125 16.25Z",
    fill: "url(#paint4_linear_1952_14)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 22.5C6.17544 22.5 6.875 21.8004 6.875 20.9375C6.875 20.0746 6.17544 19.375 5.3125 19.375C4.44956 19.375 3.75 20.0746 3.75 20.9375C3.75 21.8004 4.44956 22.5 5.3125 22.5Z",
    fill: "url(#paint5_linear_1952_14)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 25.625C6.17544 25.625 6.875 24.9254 6.875 24.0625C6.875 23.1996 6.17544 22.5 5.3125 22.5C4.44956 22.5 3.75 23.1996 3.75 24.0625C3.75 24.9254 4.44956 25.625 5.3125 25.625Z",
    fill: "url(#paint6_linear_1952_14)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M15.0003 5.89258L4.04215 15.4682C4.02402 15.4838 4.00215 15.4895 3.9834 15.5026C4.09527 15.6851 4.2434 15.8426 4.41715 15.9657C4.42902 15.9563 4.44215 15.9488 4.4534 15.9388L15.0003 6.72258L25.5459 15.9382C25.5578 15.9488 25.5715 15.9557 25.5834 15.9657C25.7571 15.8426 25.9053 15.6851 26.0171 15.5032C25.9984 15.4901 25.9759 15.4845 25.9584 15.4688L15.0003 5.89258Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8095 13.442L15.8288 2.81453C15.3557 2.39516 14.6445 2.39516 14.1713 2.81453L2.19071 13.442C1.93321 13.6714 1.91009 14.0658 2.13946 14.3233C2.14321 14.3277 2.14696 14.3314 2.15071 14.3358L3.17321 15.4264C3.40384 15.6727 3.78884 15.6914 4.04196 15.4683L15.0001 5.89266L25.9582 15.4689C26.212 15.6914 26.5963 15.6733 26.827 15.427L27.8495 14.3364C28.0857 14.0845 28.0732 13.6895 27.8213 13.4533C27.8176 13.4495 27.8138 13.4458 27.8095 13.442Z",
    fill: "url(#paint7_linear_1952_14)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 19.375C6.17544 19.375 6.875 18.6754 6.875 17.8125C6.875 16.9496 6.17544 16.25 5.3125 16.25C4.44956 16.25 3.75 16.9496 3.75 17.8125C3.75 18.6754 4.44956 19.375 5.3125 19.375Z",
    fill: "url(#paint8_linear_1952_14)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M15.0003 5.89258L4.04215 15.4682C4.02402 15.4838 4.00215 15.4895 3.9834 15.5026C4.03777 15.5913 4.10152 15.6738 4.17152 15.7495C4.1959 15.732 4.22527 15.7232 4.24777 15.7032L15.0003 6.30758L25.7521 15.7032C25.7746 15.7232 25.8046 15.732 25.829 15.7495C25.899 15.6738 25.9628 15.5913 26.0171 15.5026C25.9984 15.4895 25.9759 15.4838 25.9584 15.4682L15.0003 5.89258Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1952_14",
    x1: 23.125,
    y1: 14.6875,
    x2: 26.25,
    y2: 14.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FECD76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#FAC666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#F3BC4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#EAAD2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAAD29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1952_14",
    x1: 23.125,
    y1: 20.9375,
    x2: 26.25,
    y2: 20.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FECD76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#FAC666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#F3BC4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#EAAD2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAAD29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1952_14",
    x1: 23.125,
    y1: 24.0625,
    x2: 26.25,
    y2: 24.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FECD76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#FAC666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#F3BC4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#EAAD2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAAD29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1952_14",
    x1: 23.125,
    y1: 17.8125,
    x2: 26.25,
    y2: 17.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FECD76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#FAC666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#F3BC4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#EAAD2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAAD29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1952_14",
    x1: 3.75,
    y1: 14.6875,
    x2: 6.875,
    y2: 14.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FECD76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#FAC666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#F3BC4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#EAAD2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAAD29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1952_14",
    x1: 3.75,
    y1: 20.9375,
    x2: 6.875,
    y2: 20.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FECD76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#FAC666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#F3BC4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#EAAD2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAAD29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1952_14",
    x1: 3.75,
    y1: 24.0625,
    x2: 6.875,
    y2: 24.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FECD76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#FAC666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#F3BC4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#EAAD2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAAD29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1952_14",
    x1: 15.0001,
    y1: 2.30266,
    x2: 15.0001,
    y2: 16.0602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D43A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9360C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1952_14",
    x1: 3.75,
    y1: 17.8125,
    x2: 6.875,
    y2: 17.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FECD76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#FAC666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#F3BC4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#EAAD2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAAD29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeicon);
export default __webpack_public_path__ + "static/media/homeicon.b0b9023fb45f1e89f400dd408fef5648.svg";
export { ForwardRef as ReactComponent };